import { render, staticRenderFns } from "./UpdateBoInvestPurpose.vue?vue&type=template&id=7340baab&scoped=true"
import script from "./UpdateBoInvestPurpose.vue?vue&type=script&lang=js"
export * from "./UpdateBoInvestPurpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7340baab",
  null
  
)

export default component.exports